import React, { useState } from 'react';
import { Modal, ModalActions, ModalBody } from 'components/ui/modal';
import TextField from 'components/v2/forms/TextField';
import Label from 'components/v2/forms/Label';
import Alert from 'components/ui/Alert';
import { useTranslation } from 'react-i18next';

export default function RenameReportModal({ report, isOpen, onClose, onSave }) {
  const { t } = useTranslation();
  const [name, setName] = useState(report?.name);
  const [errors, setErrors] = useState([]);

  if (!isOpen) {
    return null;
  }

  function validate() {
    const errors = [];
    const maxNameLength = 100;

    if (!name?.trim()) errors.push(t('PLEASE_PROVIDE_THE_REPORT_NAME'));

    if (name?.length > maxNameLength)
      errors.push(t('TOO_BIG_AMOUNT_ERROR', { maxAmount: maxNameLength }));

    return errors;
  }

  function handleSave() {
    const errors = validate();
    setErrors(errors);

    console.log(errors);
    if (errors.length === 0 && onSave)
      onSave({ ...report, name, id: report._id });
  }

  function renderErrors() {
    if (errors.length === 0) return;

    return (
      (<Alert
        dataTestId="Alert-55c44ac4"
        type="error"
        title={t('PLEASE_ADDRESS_THE_FOLLOWING_ISSUES')}
        className="mb-4">
        <ul data-testid="ul-a4189104">
          {errors.map((message, i) => (
            <li data-testid={`li-634658f4-${i}`} key={i}>{message}</li>
          ))}
        </ul>
      </Alert>)
    );
  }

  function handleChange(name) {
    setName(name);
  }
  const primaryAction = {
    label: '',
    onClick: handleSave,
  };

  const secondaryActions = [
    {
      label: t('CANCEL'),
      onClick: onClose,
    },
  ];
  return (
    (<Modal
      dataTestId="Modal-ecbba99d"
      title={t('RENAME_REPORT')}
      isOpen={isOpen}
      onClose={onClose}>
      <ModalBody dataTestId="ModalBody-a3ded1d7">
        {renderErrors()}
        <Label dataTestId="Label-dcd85414" className="mb-1">New Name</Label>
        <TextField dataTestId="TextField-4ee8c131" value={name} onChange={handleChange} />
      </ModalBody>
      <ModalActions
        dataTestId="ModalActions-4bb649dd"
        primaryAction={primaryAction}
        secondaryActions={secondaryActions} />
    </Modal>)
  );
}
